export const BOATS = [
  {
    slug: "aquastays-drift",
    name: "Aquastays Drift",
    tagline: "Wake to the gentle sway of Lough Ree.",
    status: "available",
    bookingUrl: "https://aquastays.guestybookings.com/en/properties/69dff123051f000012a8ddb6",
    guests: 2,
    bedrooms: 1,
    bathrooms: 1,
    location: "Inner Lakes Marina, Killinure, Athlone",
    description:
      "A unique houseboat experience surrounded by water. Whether you're seeking an escape from the hustle and bustle, or just some plain old relaxation, this houseboat provides the opportunity to do just that. Switch off and relax, or use as a base to explore. Wake up to the gentle sway, the sunset (or rain) from one of two outdoor private decks. Create memories that will last until your next visit.",
    short:
      "A boutique houseboat moored on the still waters of Lough Ree — twin decks, private cabin, full kitchen.",
    heroImage:
      "https://res.cloudinary.com/dczcnlx82/image/upload/v1781090383/welcome_aboard3.jpg",
    gallery: [
      // 1 — hero: exterior hero shot
      "https://res.cloudinary.com/dczcnlx82/image/upload/v1781090383/welcome_aboard3.jpg",
      // 2 — bedroom with porthole + warm accent lighting
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/bedroom_portal3_tq492a.jpg",
      // 3 — exterior stern, blue sky, modern lines
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/twoStern_a2magb.jpg",
      // 4 — deck with water view
      "https://res.cloudinary.com/dczcnlx82/image/upload/v1781026113/20260601_153247_rw4ilt.jpg",
      // 5 — bed framed by open glass doors + water view
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/To_Time_to_Read_kchpcj.jpg",
      // 6 — living / dining space in bright natural light
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/sit_and_chill3_nxslbe.jpg",
      // 7 — through-the-portal corridor, contemporary design detail
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/throught_the_portal2_axf8wx.jpg",
      // 8 — stairway to roof terrace, architectural
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/Sneak_Up_To_Roof_Terrace_cilv9a.jpg",
      // 9 — brunch table, lifestyle
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/BrunchTime_fxhpqr.jpg",
      // 10 — full exterior wide shot
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/20260601_153247_ljzpkt.jpg",
    ],
    highlights: [
      { title: "Self check-in", body: "Check yourself in with the lockbox." },
      { title: "Free parking", body: "One of the few places in the area with free on-site parking." },
      { title: "Twin private decks", body: "Two outdoor decks to catch sunrise and sunset." },
    ],
    amenities: [
      { icon: "Waves", label: "Waterfront" },
      { icon: "ChefHat", label: "Full kitchen" },
      { icon: "ParkingCircle", label: "Free parking" },
      { icon: "Snowflake", label: "Air conditioning" },
      { icon: "Sun", label: "Twin decks" },
      { icon: "Refrigerator", label: "Fridge" },
      { icon: "Microwave", label: "Microwave" },
      { icon: "Wifi", label: "Wi-Fi" },
      { icon: "Coffee", label: "Coffee & tea" },
      { icon: "Bath", label: "Hot shower" },
      { icon: "KeyRound", label: "Self check-in" },
      { icon: "AlarmSmoke", label: "Smoke alarm" },
    ],
  },
  {
    slug: "aquastays-lily",
    name: "Aquastays Lily",
    tagline: "Lily has arrived.",
    status: "available",
    bookingUrl: null,
    guests: 2,
    bedrooms: 1,
    bathrooms: 1,
    location: "Inner Lakes Marina, Killinure, Athlone",
    description:
      "A mirror image of Drift, moored alongside her at Inner Lakes Marina. Same twin private decks, same full kitchen, same easy self check-in — a second chance to wake up to the still waters of Lough Ree.",
    short: "A second boutique houseboat on Lough Ree. Same marina, same decks, same water.",
    heroImage:
      "https://res.cloudinary.com/dczcnlx82/image/upload/v1781090383/welcome_aboard3.jpg",
    gallery: [
      "https://res.cloudinary.com/dczcnlx82/image/upload/v1781090383/welcome_aboard3.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/bedroom_portal3_tq492a.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/twoStern_a2magb.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/v1781026113/20260601_153247_rw4ilt.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/To_Time_to_Read_kchpcj.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/sit_and_chill3_nxslbe.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/throught_the_portal2_axf8wx.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/Sneak_Up_To_Roof_Terrace_cilv9a.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/BrunchTime_fxhpqr.jpg",
      "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400/20260601_153247_ljzpkt.jpg",
    ],
    highlights: [
      { title: "Self check-in", body: "Check yourself in with the lockbox." },
      { title: "Free parking", body: "One of the few places in the area with free on-site parking." },
      { title: "Twin private decks", body: "Two outdoor decks to catch sunrise and sunset." },
    ],
    amenities: [
      { icon: "Waves", label: "Waterfront" },
      { icon: "ChefHat", label: "Full kitchen" },
      { icon: "ParkingCircle", label: "Free parking" },
      { icon: "Snowflake", label: "Air conditioning" },
      { icon: "Sun", label: "Twin decks" },
      { icon: "Refrigerator", label: "Fridge" },
      { icon: "Microwave", label: "Microwave" },
      { icon: "Wifi", label: "Wi-Fi" },
      { icon: "Coffee", label: "Coffee & tea" },
      { icon: "Bath", label: "Hot shower" },
      { icon: "KeyRound", label: "Self check-in" },
      { icon: "AlarmSmoke", label: "Smoke alarm" },
    ],
  },
];

export const AMENITIES = [
  { icon: "Waves", label: "Waterfront" },
  { icon: "ChefHat", label: "Kitchen" },
  { icon: "ParkingCircle", label: "Free parking" },
  { icon: "Snowflake", label: "Air conditioning" },
  { icon: "Sun", label: "Patio / Balcony" },
  { icon: "Refrigerator", label: "Fridge" },
  { icon: "Microwave", label: "Microwave" },
  { icon: "AlarmSmoke", label: "Smoke alarm" },
  { icon: "Wifi", label: "Wi-Fi" },
  { icon: "Coffee", label: "Coffee & tea" },
  { icon: "Bath", label: "Hot shower" },
  { icon: "KeyRound", label: "Self check-in" },
];

export const CONTACT = {
  email: "dru@aquastays.com",
  phone: "087 6622682",
  phoneIntl: "+353876622682",
  location: "Inner Lakes Marina, Killinure, Athlone, Co. Westmeath, Ireland",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_water-escape/artifacts/bgjz9aih_aquastays_logo_large.png";
